import { render, staticRenderFns } from "./CourseGoodsList.vue?vue&type=template&id=068b978d&"
import script from "./CourseGoodsList.vue?vue&type=script&lang=js&"
export * from "./CourseGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./CourseGoodsList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports